import { createSelector } from 'reselect'

export const getAdsLoading = createSelector(
  (state) => state && state.ads && state.ads.list && state.ads.list.isLoading ? state.ads.list.isLoading : false,
  (isLoading) => isLoading
)
